module.exports = __webpack_public_path__ + "img/h12.bb90c0c4.jpg";